$(function () {
	const classes = {
		openModal: 'js-open-remodal',
		closeModal: 'js-remodal-close',
		remodal: 'remodal',
		remodalWrapper: 'remodal-wrapper',
		remodalAjax: 'js-ajax-remodal',
		form: 'js-form'
	}
	let isLoading = false
	$(document).on('click', ajaxModalHandler)

	async function ajaxModalHandler(event) {
		const target = $(event.target)
		if (target.closest(`.${classes.openModal}`).length) {
			destroyModal()
			await openModal(target)
		}
		if (target.hasClass(classes.remodalAjax) || target.closest(`.${classes.closeModal}`).length) {
			destroyModal()
		}
	}

	function destroyModal() {
		const activeModal = $(`.${classes.remodalAjax} .${classes.remodal}`)
		if (activeModal.length){
			activeModal.remodal().destroy()
		}
	}

	async function openModal(target) {
		if (isLoading) return
		isLoading = true
		const attributes = getAttributesForModal(target)
		await fetchModal(attributes).done(function (res) {
			const remodal = $(res).remodal()
			remodal.$wrapper.addClass(classes.remodalAjax)
			initHelpers(remodal.$modal)
			remodal.open()
		}).always(function (){
			isLoading = false
		})
	}

	function getAttributesForModal(element){
		const view = element.data().modalView
		const data = element.data().modalOptions || "{}"
		return {view, data}
	}

	function fetchModal(queryData) {
		const {view, data} = queryData
		return $.ajax({
			url: `/ajax_modal/`,
			method: 'GET',
			data: {
				view: view,
				data
			}
		})
	}

	function initHelpers(modal) {
		const forms = $(modal).find(`.${classes.form}`)
		if (forms.length) {
			initTurboForms(forms)
			initLabel(forms)
			initMask(forms)
		}
	}
})

